import { Box, Button, Tooltip } from "@chakra-ui/react";
import { Link } from "react-router-dom/cjs/react-router-dom";
import { ChatState } from "../Context/ChatProvider";
import logo from '../dbs-logo.png'
import ProfileModal from "./miscellaneous/ProfileModal";
import { useHistory } from "react-router-dom";
import { useState } from "react";

const Menu = () => {


  const [nav,setNav]=useState(false)
  const {
    user,
    setUser,
  } = ChatState();


  const history = useHistory();
  const logoutHandler = () => {
    localStorage.removeItem("userInfo");
    setUser();
    history.push("/login");
  };






  return (
    <Box
      alignItems="center"
      flexDir="row"
      bg="white"

      w={{ base: "full" }}


    >

      <nav className="bg-white border-gray-200">
        <div className="max-w-screen-xl flex flex-wrap items-center justify-between mx-auto p-4">
        <Link to='/' > <img src={logo} className="min-w-16 h-20" alt="DBS Logo" /></Link>
            
          <button onClick={()=> nav==true?setNav(false):setNav(true)} type="button" className="inline-flex items-center p-2 w-10 h-10 justify-center text-sm text-gray-500 rounded-lg md:hidden hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-200 " aria-controls="navbar-default" aria-expanded="false">
            <span className="sr-only">Open main menu</span>
            <svg className="w-5 h-5" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 17 14">
              <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M1 1h15M1 7h15M1 13h15" />
            </svg>
          </button>
          <div className={`${nav==true?'block':'hidden'} w-full md:block md:w-auto`} id="navbar-default">
            <ul className="font-medium flex flex-col items-start p-4 md:p-0 mt-4 border border-gray-100 rounded-lg bg-gray-50 md:flex-row flex-wrap md:space-x-8 rtl:space-x-reverse md:mt-0 md:border-0 md:bg-white ">
              <li>
                <Link to='/student' >

                  <div className="w-full h-full flex justify-center items-center text-base  lg:hover:border-b border-yellow-500 py-2 text-gray-500 hover:text-yellow-500 duration-100 ease-linear">
                    <i className="fa-solid fa-graduation-cap  mr-2"></i>
                    Etudient
                  </div>

                </Link>
              </li>
              <li>
                <Link to='/teacher' >

                  <div className="w-full h-full flex justify-center items-center text-base lg:hover:border-b border-yellow-500 py-2 text-gray-500 hover:text-yellow-500 duration-100 ease-linear">
                    <i className="fa-solid fa-user-large  mr-3"></i>
                    Professeur
                  </div>

                </Link>
              </li>
              <li>
                <Link to='/level' >

                  <div className="w-full h-full flex justify-center items-center text-base  lg:hover:border-b border-yellow-500 py-2 text-gray-500 hover:text-yellow-500 duration-100 ease-linear">
                    <i className="fa-solid fa-layer-group   mr-3"></i>
                    Niveaux
                  </div>

                </Link>
              </li>
              <li>
                <Link to='/group' >

                  <div className="w-full h-full flex justify-center items-center text-base  lg:hover:border-b border-yellow-500 py-2 text-gray-500 hover:text-yellow-500 duration-100 ease-linear">
                    <i className="fa-solid fa-users-line  mr-3"></i>
                    Group
                  </div>
                </Link>
              </li>
              <li>
                <Link to='/payement' >

                  <div className="w-full h-full flex justify-center items-center text-base  lg:hover:border-b border-yellow-500 py-2 text-gray-500 hover:text-yellow-500 duration-100 ease-linear">
                    <i className="fa-regular fa-credit-card  mr-3"></i>
                    Payement
                  </div>

                </Link>
              </li>
              <li>
                <Link to='/ins' >

                  <div className="w-full h-full flex justify-center items-center text-base  lg:hover:border-b border-yellow-500 py-2 text-gray-500 hover:text-yellow-500 duration-100 ease-linear">
                    <i className="fa-solid fa-file-pen  mr-2"></i>
                    Pré-Inscription
                  </div>

                </Link>
              </li>
              <li>
                <Link to='/user' >

                  <div className="w-full h-full flex justify-center items-center text-base  lg:hover:border-b  border-yellow-500 py-2 text-gray-500 hover:text-yellow-500 duration-100 ease-linear">
                    <i className="fa-solid fa-image-portrait  mr-3"></i>
                    Utilisateur
                  </div>

                </Link>
              </li>
              <li>
                

                  <div onClick={logoutHandler} className="w-full h-full flex justify-center items-center text-base  lg:hover:border-b  border-yellow-500 py-2 text-gray-500 hover:text-yellow-500 duration-100 ease-linear">
                    <i className="fa-solid fa-arrow-right-from-bracket  mr-3"></i>
                    Déconnexion
                  </div>

           
              </li>
            </ul>
          </div>
        </div>
      </nav>
      {/* <div className=" bg-white w-full h-full  py-1 px-4  shadow-gray-50 drop-shadow-md  text-xl " style={{ color: "grey" }} >

        <div className="w-full flex items-center justify-start"
        >
          <div className="w-20 flex flex-col justify-start align-middle items-center">
            <img className="min-w-20 mr-8" src={logo} alt="M" />
          </div>

          <Link to='/student' >

            <div className="w-full h-full flex justify-center items-center text-base mr-7 hover:border-b border-yellow-500 py-2 text-gray-500 hover:text-yellow-500 duration-100 ease-linear">
              <i className="fa-solid fa-graduation-cap  mr-2"></i>
              Etudient
            </div>

          </Link>

          <Link to='/teacher' >

            <div className="w-full h-full flex justify-center items-center text-base mr-7 hover:border-b border-yellow-500 py-2 text-gray-500 hover:text-yellow-500 duration-100 ease-linear">
              <i className="fa-solid fa-user-large  mr-3"></i>
              Professeur
            </div>

          </Link>

          <Link to='/level' >

            <div className="w-full h-full flex justify-center items-center text-base mr-7 hover:border-b border-yellow-500 py-2 text-gray-500 hover:text-yellow-500 duration-100 ease-linear">
              <i className="fa-solid fa-layer-group   mr-3"></i>
              Niveaux
            </div>

          </Link>

          <Link to='/group' >

            <div className="w-full h-full flex justify-center items-center text-base mr-7 hover:border-b border-yellow-500 py-2 text-gray-500 hover:text-yellow-500 duration-100 ease-linear">
              <i className="fa-solid fa-users-line  mr-3"></i>
              Group
            </div>

          </Link>

          <Link to='/payement' >

            <div className="w-full h-full flex justify-center items-center text-base mr-7 hover:border-b border-yellow-500 py-2 text-gray-500 hover:text-yellow-500 duration-100 ease-linear">
              <i className="fa-regular fa-credit-card  mr-3"></i>
              Payement
            </div>

          </Link>

          <Link to='/user' >

            <div className="w-full h-full flex justify-center items-center text-base mr-7 hover:hover:border-b border-yellow-500 border-yellow-500 py-2 text-gray-500 hover:text-yellow-500 duration-100 ease-linear">
              <i className="fa-solid fa-image-portrait  mr-3"></i>
              Utilisateur
            </div>

          </Link>
        </div>


      </div> */}

    </Box>
  );
};

export default Menu;





